import { z } from 'zod';
/** Correlation types for async command outcomes on `control/responses`. */
export const IOT_COMMAND_CORRELATION_TYPE = {
    GATEWAY_CONFIG_PUSH: 'gateway_config_push',
    CONTAINER_SLOT_SCAN_JOB: 'container_slot_scan_job',
    BATCH_WAFER_TRANSFER_JOB: 'batch_wafer_transfer_job',
};
export const IotCommandCorrelationSchema = z.object({
    type: z.string().min(1),
    id: z.string().min(1),
});
/** IoT Rule → control-response-router Lambda ingress (loose). */
const iotBoolean = z.preprocess((value) => {
    if (value === 'true' || value === true)
        return true;
    if (value === 'false' || value === false)
        return false;
    return value;
}, z.boolean());
export const IoTControlResponseOutcomeLooseSchema = z
    .object({
    requestId: z.string().min(1),
    success: iotBoolean,
    command: z.string().optional(),
    correlation: IotCommandCorrelationSchema.optional(),
    orchestratorId: z.string().optional(),
    topic: z.string().optional(),
    tenantId: z.string().optional(),
    gatewayTopicSegment: z.string().optional(),
    data: z.unknown().optional(),
    error: z
        .object({
        code: z.string().optional(),
        message: z.string().optional(),
    })
        .optional(),
})
    .passthrough();
//# sourceMappingURL=iot-command-correlation.js.map